if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const clickedMediaId = this.openedBy.getAttribute('data-media-id');
        
        // Get the modal content container
        const modalContent = this.querySelector('.product-media-modal__content');
        
        if (modalContent) {
          // Hide ALL images in the modal
          const allImages = modalContent.querySelectorAll('img[data-media-id]');
          allImages.forEach((img) => {
            if (img.getAttribute('data-media-id') !== clickedMediaId) {
              img.style.display = 'none';
              img.classList.remove('active');
            } else {
              img.style.display = 'block';
              img.classList.add('active');
            }
          });
        }

        // Find the active media element
        const activeMedia = this.querySelector(`[data-media-id="${clickedMediaId}"]`);
        
        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          if (container && activeMedia.width) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    }
  );
}